import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Box, IconButton } from '@mui/material'
import { withStyles } from '@mui/styles'
import SearchIcon from '@mui/icons-material/Search'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
//import RestoreIcon from '@mui/icons-material/RestoreFromTrash'

import { usePermissions } from '../../../../core/hooks'
import { useAjaxContext } from '../../../../core/ajax'
import { setTariffs } from '../../../tariffs'
import { useTariffsDialogs } from '../../hooks'
import { tableActionsStyles } from './table-actions.style'

export const TableActions = withStyles(tableActionsStyles)((props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { deleteById } = useAjaxContext()
  const { isPrescriptor } = usePermissions()
  const tariffId = props.row.original['idTarifa']
  const searchParams = useSelector((state) => state.tariffs.search)

  const { warnPermanentDeletion } = useTariffsDialogs()

  const handleGoToDetail = () => navigate(`/tariffs/${tariffId}`)

  const handleEdit = () => navigate(`/tariffs/${tariffId}/edit`)

  //Delete action, with modal
  const handleDelete = () => {
    deleteById('tarifa/eliminar', tariffId)
      .then(() => {
        dispatch(setTariffs(searchParams))
      })
      .catch(() => console.error('Error deleting tariff'))
  }
  const handleCallDelete = () => {
    warnPermanentDeletion(handleDelete)
  }

  // const handleActivate = () => {
  //   console.debug('Not implemented yet')
  // }

  const tariffButtons = {
    edit: {
      onClick: handleEdit,
      icon: <EditIcon />,
    },
    delete: {
      onClick: handleCallDelete,
      icon: <DeleteIcon />,
    },
    detail: {
      onClick: handleGoToDetail,
      icon: <SearchIcon />,
    },
    // activate: {
    //   onClick: handleActivate,
    //   icon: <RestoreIcon />,
    // },
  }

  const availableActions = ['detail']
  if (isPrescriptor) {
    availableActions.push('edit')
    // availableActions.push(tariffActive ? 'delete' : 'activate')
    availableActions.push('delete')
  }

  return (
    <Box className={props.classes.actionRow} p={0}>
      {availableActions.map((action) => {
        return (
          <IconButton
            className={props.classes.actionButton}
            key={action}
            size="small"
            onClick={tariffButtons[action].onClick}
          >
            {tariffButtons[action].icon}
          </IconButton>
        )
      })}
    </Box>
  )
})
